module.exports = __webpack_public_path__ + "img/gld_gbt68_2000.prt.3339a995.jpg";